import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";

interface CustomerNotesModalProps {
  isOpen: boolean;
  onClose: () => void;
  notes: string;
}

export const CustomerNotesModal: React.FC<CustomerNotesModalProps> = ({
  isOpen,
  onClose,
  notes,
}) => {
  return (
    <Dialog
      maxWidth="sm"
      fullWidth={true}
      open={isOpen}
      onClose={onClose}
      aria-labelledby="customer-notes-title"
    >
      <DialogTitle id="customer-notes-title">Customer Notes</DialogTitle>
      <DialogContent dividers style={{ whiteSpace: "pre-wrap" }}>
        {notes.trim().length === 0 ? (
          <Typography>No notes available.</Typography>
        ) : (
          <Typography component="pre" style={{ whiteSpace: "pre-wrap" }}>
            {notes}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
